export enum Tests {
    CompletePanel = "851fea73-9913-4701-837a-2af9cdbec05b"
}